import actions from "./actions";

export default {
  namespaced: true,
  state: {
    questions: [],
    answers: []
  },
  mutations: {
    setQuestions(state, questions) {
      state.questions = questions;
    },
    setAnswers(state, answers) {
      state.answers = answers;
    }
  },
  actions
};
